import { motion } from "framer-motion";
import { STEPS, IMAGES } from "@/lib/site";
import { Reveal } from "@/components/site/Reveal";

export default function HowItWorks() {
  return (
    <section id="how" data-testid="how-it-works" className="relative bg-[#D9F4CD] py-24 md:py-40 border-t border-[#17320B]/10">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-20">
            <div>
              <span className="font-mono-eb text-xs uppercase tracking-[0.3em] text-[#7B9C62]">/ How It Works</span>
              <h2 className="font-display uppercase text-4xl md:text-6xl tracking-tighter leading-[0.9] mt-5 text-[#17320B]">
                Choose. Pay.<br /><span className="text-[#7B9C62]">Collect.</span>
              </h2>
            </div>
            <p className="max-w-sm text-[#17320B]/70 text-base md:text-lg">
              From craving to cup in under a minute. No queue, no barista, no cash {"\u2014"} just tap and go.
            </p>
          </div>
        </Reveal>

        <div className="grid lg:grid-cols-[1.3fr_0.7fr] gap-6 md:gap-8 items-stretch">
          <div className="grid sm:grid-cols-2 gap-4 md:gap-6">
            {STEPS.map((s, i) => (
              <Reveal key={s.no} delay={i * 0.08}>
                <div className="relative group border border-[#17320B]/12 hover:border-[#7B9C62] rounded-sm p-8 bg-white transition-colors duration-500 h-full">
                  <div className="flex items-center justify-center h-12 w-12 rounded-full bg-[#17320B] text-[#D9F4CD] font-display text-xl mb-6">
                    {s.no}
                  </div>
                  <h3 className="font-display uppercase text-2xl md:text-3xl tracking-tight mb-2 text-[#17320B]">{s.title}</h3>
                  <p className="text-[#17320B]/60 text-sm leading-relaxed">{s.body}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.15}>
            <motion.div
              whileHover={{ y: -4 }}
              className="relative h-full rounded-sm border border-[#7B9C62]/50 bg-[#C2E9FF]/40 p-8 flex flex-col items-center text-center justify-center"
            >
              <div className="font-mono-eb text-[10px] uppercase tracking-[0.25em] text-[#7B9C62] mb-6">Scan to Pay</div>
              <div className="rounded-sm bg-white p-3 border border-[#17320B]/10">
                <img src={IMAGES.qr} alt="Scan to pay QR code" className="w-40 h-40 object-contain" />
              </div>
              <div className="mt-6 font-mono-eb text-[10px] uppercase tracking-[0.2em] text-[#17320B]/60">Pay instantly via UPI</div>
              <div className="mt-4 flex flex-wrap items-center justify-center gap-2.5">
                <span className="flex items-center h-9 rounded-md bg-white border border-[#17320B]/10 px-3 font-display text-sm tracking-tight">
                  <span className="text-[#FF7A00]">U</span><span className="text-[#0A7D3B]">P</span><span className="text-[#17320B]">I</span>
                </span>
                <span className="flex items-center h-9 rounded-md bg-white border border-[#17320B]/10 px-3">
                  <img src="/assets/pay_googlepay.svg" alt="Google Pay" className="h-4 w-auto" />
                </span>
                <span className="flex items-center h-9 rounded-md bg-white border border-[#17320B]/10 px-3">
                  <img src="/assets/pay_phonepe.svg" alt="PhonePe" className="h-4 w-auto" />
                </span>
                <span className="flex items-center h-9 rounded-md bg-white border border-[#17320B]/10 px-3">
                  <img src="/assets/pay_paytm.svg" alt="Paytm" className="h-4 w-auto" />
                </span>
              </div>
              <p className="text-[#17320B]/50 text-sm mt-4">Cashless, contactless, instant.</p>
            </motion.div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
